import React from 'react';

import bn from 'utils/bemnames';

import {
  Nav,
  NavItem,
  NavLink as BSNavLink,
  // UncontrolledTooltip,
  Collapse,
} from 'reactstrap';
import { NavLink } from 'react-router-dom';

import {
  MdHelp,
  MdSearch,
  MdChromeReaderMode,
  MdKeyboardArrowDown,
  MdGavel
} from 'react-icons/lib/md';

const sidebarBackground = {
  backgroundImage: 'url("/img/sidebar/sidebar-4.jpg")',
  backgroundSize: 'cover',
  backgroundRepeat: 'no-repeat',
};

const navProcesso = [
  { to: '/', name: 'Cadastrar', exact: true, Icon: MdChromeReaderMode },
  { to: '/pesquisa', name: 'Pesquisar', exact: false, Icon: MdSearch },
];

const navItens = [
  { to: '/ajuda', name: 'Ajuda', exact: false, Icon: MdHelp },
];

const bem = bn.create('sidebar');

class PainelLateral extends React.Component {
  state = {
    isOpenProcesso: true,
  };

  handleClick = name => () => {
    this.setState(prevState => {
      const isOpen = prevState[`isOpen${name}`];

      return {
        [`isOpen${name}`]: !isOpen,
      };
    });
  };

  render() {
    return (
      <aside className={bem.b()} data-image="/img/sidebar/sidebar.jpg">
        <div className={bem.e('background')} style={sidebarBackground} />
        <div className={bem.e('content')}>

          <Nav vertical>
            <NavItem
              className={bem.e('nav-item')}
              onClick={this.handleClick('Processo')}
            >
              <BSNavLink className={bem.e('nav-item-collapse')}>
                <div className="d-flex">
                  <MdGavel className={bem.e('nav-item-icon')} size="1.5rem" />
                  <span className="">Processo</span>
                </div>
                <MdKeyboardArrowDown
                  className={bem.e('nav-item-icon')}
                  size="1rem"
                  style={{
                    padding: 0,
                    transform: this.state.isOpenProcesso
                      ? 'rotate(0deg)'
                      : 'rotate(-90deg)',
                    transitionDuration: '0.3s',
                    transitionProperty: 'transform',
                  }}
                />
              </BSNavLink>
            </NavItem>
            <Collapse isOpen={this.state.isOpenProcesso}>
              {navProcesso.map(({ to, name, exact, Icon, acao }, index) => (
                <NavItem key={index} className={bem.e('nav-item')}>
                  <BSNavLink
                    id={`navItem-${name}-${index}`}
                    className="text-uppercase"
                    tag={NavLink}
                    to={to}
                    activeClassName="active"
                    onClick={this.props.limparProcesso}
                    exact={exact}
                  >
                    <Icon className={bem.e('nav-item-icon')} size="1.5rem" />
                    <span className="">{name}</span>
                  </BSNavLink>
                </NavItem>
              ))}
            </Collapse>
          </Nav>
          <hr />
          <Nav vertical>
            {navItens.map(({ to, name, exact, Icon }, index) => (
              <NavItem key={index} className={bem.e('nav-item')}>
                <BSNavLink
                  id={`navItem-${name}-${index}`}
                  className="text-uppercase"
                  tag={NavLink}
                  to={to}
                  activeClassName="active"
                  exact={exact}
                >
                  <Icon className={bem.e('nav-item-icon')} size="1.5rem" />
                  <span className="">{name}</span>
                </BSNavLink>
              </NavItem>
            ))}
          </Nav>
        </div>
      </aside>
    );
  }
}

export default PainelLateral;



// WEBPACK FOOTER //
// ./src/componentes/Layout/PainelLateral.js